var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ReconnectingWebSocket from "reconnecting-websocket";
import { EventEmitter } from "events";
import { getLogger } from "@parcel2go/logging";
import { Prn } from "@parcel2go/data";
var Socket = /** @class */ (function () {
    function Socket() {
        this.logger = getLogger();
        this.active = true;
        this.connected = false;
        this.eventEmitter = new EventEmitter();
        this.pinger = 0;
        this.authenticated = false;
        this.registered = false;
    }
    Socket.prototype.connect = function (accessToken, tags, authority) {
        var _this = this;
        this.authority = authority;
        this.accessToken = accessToken;
        this.tags = tags || [];
        return new Promise(function (accept, reject) {
            var host = process.env.REACT_APP_WSS || "wss://wss.serverless.p2g.systems";
            _this.logger.debug("socket connecting %j", host);
            _this.socket = new ReconnectingWebSocket(host);
            _this.socket.onopen = function (e) { return __awaiter(_this, void 0, void 0, function () {
                var e_1, e_2;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.logger.debug("socket connected");
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, this.register(this.tags)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 4];
                        case 3:
                            e_1 = _a.sent();
                            reject(e_1);
                            return [3 /*break*/, 4];
                        case 4:
                            _a.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, this.authenticate(this.accessToken, this.authority)];
                        case 5:
                            _a.sent();
                            return [3 /*break*/, 7];
                        case 6:
                            e_2 = _a.sent();
                            reject(e_2);
                            return [3 /*break*/, 7];
                        case 7:
                            if (!this.pinger) {
                                this.logger.info("starting keep alive task");
                                this.pinger = window.setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.sendMessage({ action: "ping" })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }, 420000 + Math.floor(Math.random() * 30000));
                            }
                            this.connected = true;
                            this.eventEmitter.emit("onopen", e);
                            accept();
                            return [2 /*return*/];
                    }
                });
            }); };
            _this.socket.onerror = function (e) {
                _this.logger.error("socket error %j", e);
                _this.connected = false;
                if (_this.pinger) {
                    _this.logger.info("stopping keep alive task");
                    window.clearInterval(_this.pinger);
                    _this.pinger = 0;
                }
                _this.registered = false;
                _this.authenticated = false;
                _this.eventEmitter.emit("onerror", e);
                if (!_this.active) {
                    _this.logger.info("window not active disable reconnect");
                    _this.socket.close();
                }
            };
            _this.socket.onclose = function (e) {
                _this.logger.warn("socket close %j", e);
                _this.connected = false;
                if (_this.pinger) {
                    _this.logger.info("stopping keep alive task");
                    window.clearInterval(_this.pinger);
                    _this.pinger = 0;
                }
                _this.registered = false;
                _this.authenticated = false;
                _this.eventEmitter.emit("onclose", e);
            };
            _this.socket.onmessage = _this.onSocketMessage.bind(_this);
            if (document && document.addEventListener) {
                document.addEventListener("visibilitychange", function () {
                    if (document.visibilityState === "hidden") {
                        _this.active = false;
                        _this.logger.info("window lost focus");
                        if (_this.pinger) {
                            _this.logger.info("stopping keep alive task");
                            window.clearInterval(_this.pinger);
                            _this.pinger = 0;
                        }
                    }
                    else {
                        _this.active = true;
                        _this.logger.info("window got focus");
                        if (!_this.connected) {
                            _this.logger.info("attempting reconnect");
                            _this.socket.reconnect();
                        }
                    }
                });
            }
        });
    };
    Socket.prototype.onSocketMessage = function (ev) {
        var payload = JSON.parse(ev.data);
        this.logger.debug("socket recieved %j", payload);
        this.eventEmitter.emit(payload.action, payload.data);
    };
    Socket.prototype.sendMessage = function (message) {
        this.logger.debug("socket send %j", message);
        this.socket.send(JSON.stringify(message));
    };
    Socket.prototype.authenticate = function (accessToken, authority) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                if (accessToken && authority) {
                    return [2 /*return*/, new Promise(function (accept) {
                            var authenticated = function (a) {
                                _this.logger.debug("socket authenticated %j", a);
                                _this.authenticated = true;
                                _this.eventEmitter.off("authenticated", authenticated);
                                accept(a);
                            };
                            _this.eventEmitter.on("authenticated", authenticated);
                            _this.sendMessage({
                                action: "authenticate",
                                accessToken: accessToken,
                                authority: authority,
                            });
                        })];
                }
                else {
                    return [2 /*return*/, Promise.resolve()];
                }
                return [2 /*return*/];
            });
        });
    };
    Socket.prototype.register = function (tags) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (accept) {
                        var registered = function (a) {
                            _this.logger.debug("socket registered %j", a);
                            _this.registered = true;
                            _this.eventEmitter.off("session", registered);
                            accept(a);
                        };
                        _this.eventEmitter.on("session", registered);
                        var sessionId = _this.getSessionId();
                        _this.sendMessage({
                            action: "session",
                            sessionId: sessionId,
                            tags: tags || [],
                            application: process.env.REACT_APP_NAME || "unknown",
                        });
                    })];
            });
        });
    };
    Socket.prototype.on = function (event, listener) {
        this.eventEmitter.on(event, listener);
    };
    Socket.prototype.off = function (event, listener) {
        this.eventEmitter.off(event, listener);
    };
    Socket.prototype.getSessionId = function () {
        var key = "WEBSOCKET:SESSIONID";
        try {
            var id = localStorage.getItem(key);
            if (!id) {
                var prn = Prn.generate("WEBSOCKET", "SESSIONID", process.env.REACT_APP_NAME || "unknown");
                id = prn.toString();
                localStorage.setItem(key, id);
            }
            return id;
        }
        catch (_a) {
            try {
                var id = sessionStorage.getItem(key);
                if (!id) {
                    var prn = Prn.generate("WEBSOCKET", "SESSIONID", process.env.REACT_APP_NAME || "unknown");
                    id = prn.toString();
                    sessionStorage.setItem(key, id);
                }
                return id;
            }
            catch (_b) {
                var prn = Prn.generate("WEBSOCKET", "SESSIONID", process.env.REACT_APP_NAME || "unknown");
                var id = prn.toString();
                return id;
            }
        }
    };
    Socket.prototype.sendEvent = function (data) {
        this.sendMessage(__assign({ action: "event", host: window.location.host, path: window.location.pathname, height: window.innerHeight, width: window.innerWidth, referrer: document.referrer, application: process.env.REACT_APP_NAME, version: process.env.REACT_APP_VERSION, session: this.getSessionId() }, data));
    };
    Socket.prototype.tag = function (tags) {
        this.tags = this.tags.concat(tags);
        this.sendMessage({
            action: "tag",
            tags: tags,
        });
    };
    Socket.prototype.disconnect = function () {
        this.socket.close();
    };
    Socket.prototype.reconnect = function () {
        this.socket.reconnect();
    };
    Socket.prototype.setAccessToken = function (accessToken) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.accessToken = accessToken;
                        return [4 /*yield*/, this.register(this.tags)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.authenticate(this.accessToken, this.authority)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return Socket;
}());
export { Socket };
export var currentSocket = new Socket();
